import { toast } from 'react-hot-toast';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateBrandStrategy } from '../services';
import { useBrandStrategyStore } from '../store/brand-strategy-store';
import { BrandStrategy } from '../types';

export const useUpdateGettingToKnowYou = (projectId: string) => {
  const queryClient = useQueryClient();
  const { brandStrategyId, brandStrategy } = useBrandStrategyStore();

  return useMutation({
    mutationFn: async (data: {
      why_start_the_business: string;
      unique_industry_perspective: string;
      proudest_moment_in_business: string;
      purpose: string;
      mission: string;
      vision: string;
    }) => {
      if (!brandStrategyId || !brandStrategy) {
        throw new Error('Brand strategy data is required');
      }

      const updatedStrategy: BrandStrategy = {
        ...brandStrategy,
        why_start_the_business: data.why_start_the_business || null,
        unique_industry_perspective: data.unique_industry_perspective || null,
        proudest_moment_in_business: data.proudest_moment_in_business || null,
        purpose: data.purpose || null,
        mission: data.mission || null,
        vision: data.vision || null,
      };

      const response = await updateBrandStrategy(
        projectId,
        brandStrategyId,
        updatedStrategy
      );
      return response.data;
    },
    onSuccess: (data) => {
      toast.success('Getting to know you updated successfully');
      useBrandStrategyStore.getState().setBrandStrategy(data);
      queryClient.invalidateQueries({ queryKey: ['brand-story', projectId] });
      queryClient.invalidateQueries({ queryKey: ['brandStrategy', projectId] });
    },
    onError: (error) => {
      console.error('Error updating getting to know you', error);
      toast.error('Failed to update getting to know you');
    },
  });
};
